import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,BulkEdit,AddListItem,
        DynamicListArea,DownloadTemplate,LoadGraphic,Step,Segment,
        SegmentComplete,DataboxGeneral} from '../components/Common';
import {Button,Box,EditSizeLabel,EditSizeLink,TextButton,
        ContactNumber,Checkbox,EditableBox,EditableArea,
        Area,MiniMinusButton,PageSelector,Table,Select,
        Info,Date} from '../components/Input';
import u from '../utilities/Utilities';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Link} from 'react-router-dom';
import store from 'store';
import "../styles/hoto-item-list.scss";

export default class HOTOItemList extends React.Component{

    settings={
        /**** Page Setup ****/
        title:"Handover Item List",
        permission:"hoto",
        url:"/hoto-item-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/add-hoto-item-entry",
        //bulkURL:"/api/add-bulk-client",
        deleteURL:"/api/delete-hoto-item-entries",
        spreadsheetURL:"/api/generate-hoto-item-spreadsheet",
        //templateURL:"/api/get-add-client-template",
        overviewURL:"/api/get-all-hoto-item-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"hoto-item-list",
        orderByField:"itemName",
        orderByType:"ascending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        download:{component:DownloadTemplate,props:{skipParams:true}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    }

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        addError:"",
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions("hoto");
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);

        this.setState({
            permissions:permissions,
            pageMenuButtons:[
              {label:"Add Entries",ref:"add",enabled:(permissions.create==2)},
              {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
              {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
              {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ],
        });
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    render=()=>{
        return (
            <AppLayout ref="layout" settings={this.settings}>
                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu settings={this.settings}
                          buttons={this.state.pageMenuButtons}
                          components={this.pageComponents}
                          selected={this.state.selected}/>

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <HOTOItem key={index}
                                          content={content}
                                          index={index}
                                          onChange={onChange}
                                          onContentChange={onContentChange}
                                          registerReference={registerRef}
                                          settings={this.settings}
                                          permissions={this.state.permissions}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class HOTOItem extends React.Component{

    state={
        step:"view",
        loading:false,
        loadText:"",
        listLength:10,
        page:1,
        startIndex:0,
        endIndex:10,
    }

    static getDerivedStateFromProps(props,state){
        state.maxPage = Math.ceil(props.content.damageList.length / state.listLength);
        return state;
    }

    onChangeDamageList=(value,label,index)=>{
        let damageList=this.props.content.damageList;
        damageList[index][label]=value;
        this.props.onChange(damageList,"damageList",this.props.index);
    }

    onAddDamageEntry=()=>{
        const keys=["label","amount","remarks"];
        let data={};
        for(var i=0; i<keys.length; i++){
            const current=this.refs[keys[i]].validate();
            if(!current.valid){
                this.setState({error:error});
                return 0;
            }
            data[keys[i]]=current.value;
        }
        this.setState({loading:true,loadText:"Adding..."});
        u.post({
           url:"/api/add-damage-entry",
           data:{
             ...data,
             hotoItemID:this.props.content.hotoItemID,
           },
           success:(entry)=>{
              let damageList=this.props.content.damageList;
              damageList.push(entry);
              this.props.onChange(damageList,"damageList",this.props.index);
              this.setState({step:"view",loading:false});
           },
           error:(error)=>{
              this.setState({error:error,loading:false});
           }
        })
    }

    onRemoveDamageEntry=()=>{
        let index=this.state.damageIndex;
        this.setState({loading:true,loadText:"Removing..."});
        u.post({
            url:"/api/remove-damage-entry",
            data:{
                hotoItemID:this.props.content.hotoItemID,
                item:this.props.content.damageList[index]
            },
            success:()=>{
                let damageList=this.props.content.damageList;
                damageList.splice(index,1);
                this.props.onChange(damageList,"damageList",this.props.index);
                this.setState({step:"view",loading:false,error:""});
            },
            error:(error)=>{
                this.setState({error:error,loading:false})
            }
        })
    }

    onChangePage=(page)=>{
        const listLength = this.state.listLength;
        if(page < 1){
            page = 1;
        }
        else if(page > this.state.maxPage){
            page=this.state.maxPage;
        }
        const startIndex = (page-1) * listLength;
        const endIndex= startIndex + listLength;
        this.setState({page:page,startIndex:startIndex,endIndex:endIndex});
    }

    onExportAssignment=()=>{
        let startDate = this.refs['startDate'].validate();
        let endDate = this.refs['endDate'].validate();
        if(moment(startDate.value).isAfter(endDate.value)){
            this.setState({error:"Start Date cannot be after End Date"});
            return 0;
        }

        this.setState({loading:true,loadText:"Preparing..."});
        u.post({
            url:"/api/hoto-export-assignment",
            data:{
                hotoItemID:this.props.content.hotoItemID,
                startDate:startDate.value,
                endDate:endDate.value
            },
            success:({filename,filestamp})=>{
                this.filename=filename;
                this.filestamp=filestamp;
                u.download(filename,filestamp);
                this.setState({loading:false,step:"download-complete",error:""});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onRedownload=()=>{
        this.setState({loading:true,loadText:"Retrying Download..."});
        u.download(this.filename,this.filestamp,()=>{
            this.setState({loading:false});
        },(error)=>{
            this.setState({error:error,loading:false});
        })
    }

    render=()=>{
        const content = this.props.content;
        const permissions=this.props.permissions;
        const canEdit=(permissions.update);
        return (
            <div style={{position:"relative",textAlign:"center"}}>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={(this.state.step=="view")}>
                    <DynamicListArea listLabel={this.props.settings.listLabel}
                                     permission={this.props.settings.permission}
                                     content={this.props.content}
                                     onChange={this.props.onChange}
                                     index={this.props.index}
                                     />

                    <div className="list-table" style={{maxHeight:"none"}}>
                      {
                        (content.damageList.length > 0)
                          ?
                          <div>
                              <h3>Damage List</h3>
                              <table>
                                  <thead>
                                      <tr>
                                          <th className="remove"/>
                                          <th>Damage</th>
                                          <th className="hoto-item-amount">Amount</th>
                                          <th>Remarks</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                  {
                                      content.damageList.map(
                                          (item,index)=>{
                                              if(index < this.state.startIndex || index >= this.state.endIndex){
                                                   return null;
                                              }
                                              return (
                                                  <tr key={index}>
                                                      <td className="remove">
                                                          <MiniMinusButton enabled={canEdit}
                                                                           onClick={()=>{this.setState({damageIndex:index,step:"remove",error:""})}}
                                                                           />
                                                      </td>
                                                      <td>
                                                        <EditableBox label="Damage"
                                                                     field="label"
                                                                     index={index}
                                                                     values={{
                                                                        value:item.label,
                                                                        enabled:canEdit
                                                                      }}
                                                                     id={{
                                                                        hotoItemID:content.hotoItemID,
                                                                        item:item,
                                                                      }}
                                                                     rules={{
                                                                        required:true
                                                                      }}
                                                                     url="/api/update-hoto-item-info"
                                                                     onChange={this.onChangeDamageList}
                                                                     />
                                                      </td>
                                                      <td className="hoto-item-amount">
                                                        <EditableBox label="Amount"
                                                                     type="number"
                                                                     field="amount"
                                                                     index={index}
                                                                     values={{
                                                                        value:item.amount,
                                                                        enabled:canEdit
                                                                      }}
                                                                     id={{
                                                                        hotoItemID:content.hotoItemID,
                                                                        item:item,
                                                                      }}
                                                                     rules={{
                                                                       required:true,
                                                                       isFloat:true
                                                                     }}
                                                                     url="/api/update-hoto-item-info"
                                                                     onChange={this.onChangeDamageList}
                                                                     />
                                                      </td>
                                                      <td>
                                                        <EditableArea label="Remarks"
                                                                      field="remarks"
                                                                      index={index}
                                                                      values={{
                                                                        value:item.remarks,
                                                                        enabled:canEdit
                                                                      }}
                                                                      id={{
                                                                        hotoItemID:content.hotoItemID,
                                                                        item:item,
                                                                      }}
                                                                      url="/api/update-hoto-item-info"
                                                                      onChange={this.onChangeDamageList}/>
                                                      </td>
                                                  </tr>
                                              )
                                          }
                                      )
                                  }
                                  </tbody>
                              </table>
                              <div style={{margin:"15px auto 5px auto"}}>
                                  {
                                      (this.state.maxPage > 1)
                                          ?
                                          <PageSelector page={this.state.page}
                                                        maxPage={this.state.maxPage}
                                                        onChange={this.onChangePage}
                                                        />
                                          :
                                          null
                                  }
                              </div>
                          </div>
                          :
                          <div className="list-placeholder">
                              <h3>No Damage Entries</h3>
                              <div>Click add below to add damage entries</div>
                          </div>
                    }

                      {
                          (canEdit)
                              ?
                              <div style={{margin:"20px auto"}}>
                                  <TextButton onClick={()=>{this.setState({step:"add",error:""})}}>Add Damage Item</TextButton>
                              </div>
                              :
                              null
                      }
                    </div>

                    <div style={{margin:"20px auto"}}>
                        <Button onClick={()=>{this.setState({step:"download",error:""})}}>Download Report</Button>
                    </div>

                </Step>

                <Step active={(this.state.step=="add")}>
                    <div style={{position:"relative",textAlign:"center",margin:"20px auto",fontSize:"14px"}}>
                        <h3>Add Damage Entry</h3>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Damage:</div>
                            <div className="segment-item-input">
                                <Box ref="label"
                                     label="Damage"
                                     rules={{required:true}}
                                     />
                            </div>
                        </div>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Amount:</div>
                            <div className="segment-item-input">
                                <Box ref="amount"
                                     label="Amount"
                                     rules={{required:true,isFloat:true}}
                                     />
                            </div>
                        </div>
                        <div className="segment-full-item">
                            <div className="segment-item-label">Remarks:</div>
                            <div className="segment-item-input">
                                <Area ref="remarks"
                                      label="Remarks"
                                      rules={{required:true,rows:5}}
                                      />
                            </div>
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <div className="list-segment-error">{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onAddDamageEntry}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={(this.state.step=="remove")}>
                    <h2>Remove Damage Entry - <span className="text-negative">{(content.damageList[this.state.damageIndex]) ? content.damageList[this.state.damageIndex].label : null}</span>?</h2>
                    <div>Note. The action cannot be undone</div>
                    <div className="segment-buttons">
                        <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        <Button onClick={this.onRemoveDamageEntry}>Confirm</Button>
                    </div>
                </Step>

                <Step active={(this.state.step=="download")} style={{position:"relative",fontSize:"14px",textAlign:"center"}}>
                    <h3>Select start & end dates to continue</h3>
                    <div style={{margin:"20px auto",width:"800px"}}>
                        Report will list all items that were handed over, taken over and damages within the respective start date & end dates
                    </div>
                    <div className="segment-full-item">
                        <div className="segment-item-label">Start Date:</div>
                        <div className="segment-item-input">
                            <Date ref="startDate"
                                  label="Start Date"
                                  range={[3,1]}
                                  />
                        </div>
                    </div>
                    <div className="segment-full-item">
                        <div className="segment-item-label">End Date:</div>
                        <div className="segment-item-input">
                            <Date ref="endDate"
                                  label="End Date"
                                  range={[3,1]}
                                  />
                        </div>
                    </div>
                    <div className="segment-buttons">
                        <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        <Button onClick={this.onExportAssignment}>Download</Button>
                    </div>
                </Step>

                <Step active={(this.state.step=="download-complete")}>
                    <div style={{padding:"20px 0"}}>
                        <h2>Report Prepared Successfully</h2>
                        <div>If the download has not automatically begin, please <TextButton style={{margin:"0"}} onClick={this.onRedownload}>click here</TextButton></div>
                        <div className="segment-buttons">
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{

    state={
        entryData:{
            damageList:[],
        },
        options:{},
        loading:false,
        loadText:"",
        step:"add",
    }

    show=(show)=>{
        this.refs[this.props.reference].show(show)
    }

    componentDidMount=()=>{
        this.getOptions();
        this.getDormitoryOptions();
    }

    getOptions=()=>{
        u.post({
            url:"/api/get-options",
            data:{
                keys:["hotoItemEstateType","hotoItemQuantity"]
            },
            success:(options)=>{
                this.setState({options:options});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    getDormitoryOptions=()=>{
        u.post({
            url:"/api/get-estate-options",
            data:{
                type:"dorm"
            },
            success:(dormOptions)=>{
                dormOptions.unshift({label:"Any Dormitory",value:"Any Dormitory"});
                this.setState({dormOptions:dormOptions});
            },
            error:(error)=>{
                this.setState({error:error})
            }
        });
    }

    onChange=(value,label,index)=>{
        let entryData=this.state.entryData;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    onAddDamage=()=>{
        let keys = ["label","amount","remarks"];
        let entry = {};
        for(var i=0; i<keys.length; i++){
            if(this.refs[keys[i]]){
                let current = this.refs[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                entry[keys[i]]=current.value;
            }
        }
        let entryData=this.state.entryData;
        entryData.damageList.push(entry);
        this.setState({step:"add",error:"",entryData:entryData});
    }

    onComplete=()=>{
        this.setState({
            step:"add",
            entryData:{
                damageList:[]
            },
            error:""
        });
    }

    onCancel=()=>{
        this.setState({
            step:"add",
            entryData:{
                damageList:[]
            },
            error:""
        });
        this.props.onToggleForm(this.props.reference,false);
    }

    onRemoveTable=(index)=>{
        let entryData=this.state.entryData;
        entryData.damageList.splice(index,1);
        this.setState({entryData:entryData});
    }

    onValidate=()=>{
        this.setState({error:""});
        const keys=["dormID","itemName","estateType","defaultQuantity"];
        let data={};
        for(var i=0; i<keys.length; i++){
            if(this.refs[keys[i]]){
                const current = this.refs[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]] = current.value;
            }
        }

        let entryData=this.state.entryData;
        data.damageList = entryData.damageList;
        this.refs[this.props.reference].onValidated(data);
    }

    render=()=>{
        const entryData=this.state.entryData;
        const options=this.state.options;
        return (
          <AddListItem ref={this.props.reference}
                       reference={this.props.reference}
                       settings={this.props.settings}
                       inList={this.props.inList}
                       onComplete={this.onComplete}
                       onToggleForm={this.props.onToggleForm}>

              <div style={{position:"relative"}}>
                  <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                  <Step active={this.state.step == "add"}>
                      <h3>Complete following fields to continue</h3>

                      <div className="segment-content">
                          <div className="segment-full-item">
                              <div className="segment-item-label">Dormitory</div>
                              <div className="segment-item-input">
                                  <Select ref="dormID"
                                          field="dormID"
                                          label="Dormitory"
                                          values={{
                                            value:entryData.dormID,
                                            options:this.state.dormOptions,
                                          }}
                                          rules={{
                                            required:true
                                          }}
                                          onChange={this.onChange}
                                          />
                              </div>
                          </div>

                          <div className="segment-full-item">
                              <div className="segment-item-label">Item Name</div>
                              <div className="segment-item-input">
                                  <Box ref="itemName"
                                       field="itemName"
                                       label="Item Name"
                                       values={{
                                         value:entryData.itemName
                                       }}
                                       rules={{
                                         required:true
                                       }}
                                       onChange={this.onChange}
                                       />
                              </div>
                          </div>

                          <div className="segment-full-item">
                              <div className="segment-item-label">Estate Type <Info title="Item can be assigned when handing over the respective estate"/></div>
                              <div className="segment-item-input">
                                  <Select ref="estateType"
                                          field="estateType"
                                          label="Estate Type"
                                          values={{
                                            value:entryData.estateType,
                                            options:options.hotoItemEstateType
                                          }}
                                          rules={{required:true}}
                                          onChange={this.onChange}
                                          />
                              </div>
                          </div>

                          <div className="segment-full-item">
                              <div className="segment-item-label">Default Quantity <Info title="When this item is added to a handover form, what is the default quantity?"/></div>
                              <div className="segment-item-input">
                                  <Select ref="defaultQuantity"
                                          field="defaultQuantity"
                                          label="Default Quantity"
                                          values={{
                                            value:entryData.defaultQuantity,
                                            options:options.hotoItemQuantity
                                          }}
                                          rules={{required:true}}
                                          onChange={this.onChange}
                                          />
                              </div>
                          </div>

                          <div style={{margin:"30px auto 20px auto",textAlign:"center"}}>
                              <h3 style={{marginTop:"0",marginBottom:"10px"}}>Damage List</h3>
                              {
                                  (entryData.damageList.length > 0)
                                      ?
                                      <div style={{position:"relative",width:"800px",maxWidth:"100%",margin:"auto",fontSize:"14px"}}>
                                          <div style={{position:"relative",fontSize:"13px"}}>
                                              <Table fields={[
                                                        {label:"Damage",field:"label"},
                                                        {label:"Amount ($)",field:"amount",className:"hoto-add-item-amount"},
                                                        {label:"Remarks",field:"remarks"},
                                                     ]}
                                                     content={entryData.damageList}
                                                     maxHeight="none"
                                                     onRemove={this.onRemoveTable}
                                                     />
                                          </div>

                                      </div>
                                      :
                                      <div className="segment-placeholder">
                                          <h3>No Damage Entries</h3>
                                          <div>
                                              List of damages the above item can sustain, to be recorded during takeover
                                          </div>
                                      </div>
                              }
                              <div style={{position:"relative",margin:"20px auto",fontSize:"13px"}}>
                                  <TextButton onClick={()=>{this.setState({step:"damage",error:""})}}>Add Damage Entry</TextButton>
                              </div>
                          </div>

                          <div className="segment-buttons">
                              <div className="segment-error">{this.state.error}</div>
                              <Button onClick={this.onCancel}>Cancel</Button>
                              <Button onClick={this.onValidate}>Create</Button>
                          </div>
                      </div>
                  </Step>

                  <Step active={this.state.step == "damage"}>
                      <h3 style={{marginBottom:"0"}}>Damage Entry</h3>

                      <div className="segment-full-item">
                          <div className="segment-item-label">Damage  <Info title="Damage can be selected when takeover is being performed"/></div>
                          <div className="segment-item-input">
                              <Box ref="label"
                                   field="label"
                                   label="Damage"
                                   rules={{
                                      required:true
                                   }}
                                   />
                          </div>
                      </div>
                      <div className="segment-full-item">
                          <div className="segment-item-label">Amount ($)</div>
                          <div className="segment-item-input">
                              <Box ref="amount"
                                   field="amount"
                                   label="Amount"
                                   rules={{
                                     required:true,
                                     isFloat:true,
                                   }}
                                   />
                          </div>
                      </div>
                      <div className="segment-full-item">
                          <div className="segment-item-label">Remarks</div>
                          <div className="segment-item-input">
                              <Area ref="remarks"
                                    field="remarks"
                                    label="Remarks"
                                    rules={{
                                        rows:5,
                                    }}
                                    />
                          </div>
                      </div>
                      <div className="segment-note" style={{margin:"20px auto"}}>List of damages the above item can sustain, to be recorded during takeover</div>
                      <div className="segment-buttons">
                          <div className="segment-error">{this.state.error}</div>
                          <Button onClick={()=>{this.setState({step:"add",error:""})}}>Cancel</Button>
                          <Button onClick={this.onAddDamage}>Add Damage</Button>
                      </div>
                  </Step>
              </div>
          </AddListItem>
        )
    }
}
